@import '../../../constants/spacing.module.less';

.applied-savings-container {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.applied-savings {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.applied-savings-icon {
  width: 24px;
  height: 24px;
  padding: @space-4;
  color: var(--pine-green);
}

.undo-button {
  font-size: 12px;
  line-height: 16px;
  height: 24px;
  padding: @space-4 @space-12;
}
